import {defaultService} from '../service'
import {loaderAtom} from '../../store/recoil/loader'
import {useSetRecoilState} from 'recoil'
import {alertAtom} from '../recoil/alert'


export const OrderPriceAction = () => {

  const loader = useSetRecoilState(loaderAtom)
  const setAlert = useSetRecoilState(alertAtom)

  const getOrderPirceTitle = async (price: number) => {

    loader({isLoading: true})

    return await defaultService.handleService({
      method: 'post',
      endPoint: `/orderPrice/getOrderPriceTitle`,
      params: {price: price}
    }).then(
      response => {
        loader({isLoading: false})
        return response.data
      },
      error => {
        loader({isLoading: false})
        setAlert({
          title: error.name,
          type: 'alert',
          message: error.message,
          isShow: true
        })
      }
    )
  }

  return {
    getOrderPirceTitle,
  }
}
